// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadasLote_BuscarMensagemProgramadaLoteResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for /mensagens_programadas_lote/buscar_mensagem_programada_lote
 * Returns a single bulk scheduled message operation by ID
 */
import type { MensagensProgramadasLote_BuscarMensagemProgramadaLoteRow } from './MensagensProgramadasLote_BuscarMensagemProgramadaLoteRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MensagensProgramadasLote_BuscarMensagemProgramadaLoteResponseDados {
dados: MensagensProgramadasLote_BuscarMensagemProgramadaLoteRow
}

export type MensagensProgramadasLote_BuscarMensagemProgramadaLoteResponse = ApiResponse<MensagensProgramadasLote_BuscarMensagemProgramadaLoteResponseDados>;

registerResponseContract('MensagensProgramadasLote_BuscarMensagemProgramadaLoteResponse', {
  dados: {
    type: 'object',
    required: true,
    fields: {
      id:                  { type: 'number',  required: true },
      periodo_inicio:      { type: 'string',  required: true },
      periodo_fim:         { type: 'string',  required: true },
      franquias:           { type: 'array',   required: false },
      template_id:         { type: 'number',  required: true },
      quantidade_clientes: { type: 'number',  required: true },
      customers_data:      { type: 'object',  required: false },
      mensagens_agendadas: { type: 'number',  required: false },
      mensagens_com_erro:  { type: 'number',  required: false },
      status:              { type: 'string',  required: true },
      data_criacao:        { type: 'string',  required: true },
      data_atualizacao:    { type: 'string',  required: false },
      usuario_id:          { type: 'number',  required: false },
      group_id:            { type: 'string',  required: false },
    },
  },
})
